import React from 'react';
import {Container} from 'reactstrap';
import ContentTable from 'components/Contents/ContentTable';

import styles from './styles.module.scss';

function ABScopeContent(props) {
  const {scopes, isLoading} = props;
  return (
    <Container className={styles['table-container']}>
      <ContentTable
        v2
        hover={false}
        className="mb-0"
        minHeight="364px"
        responsive={false}
        isFetching={isLoading}
        head={['Standard', 'Scope Type']}
        style={{tableLayout: 'fixed'}}
      >
        {scopes.map((scope, index) => {
          const {document_type, standards_code, standards_version} = scope;

          return (
            <tr key={index}>
              <td className="text-secondary">
                {[standards_code, standards_version]
                  .filter((v) => v)
                  .join(' : ')}
              </td>
              <td className="text-secondary">{document_type}</td>
            </tr>
          );
        })}
      </ContentTable>
    </Container>
  );
}

export default ABScopeContent;
